"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityFinalNegotiationQcrVariation = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const opportunity_final_negotiation_entity_1 = require("./opportunity-final-negotiation.entity");
let OpportunityFinalNegotiationQcrVariation = class OpportunityFinalNegotiationQcrVariation {
};
exports.OpportunityFinalNegotiationQcrVariation = OpportunityFinalNegotiationQcrVariation;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], OpportunityFinalNegotiationQcrVariation.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_final_negotiation_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityFinalNegotiationQcrVariation.prototype, "opportunityFinalNegotiationId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "issue", type: "varchar", length: 255 }),
    tslib_1.__metadata("design:type", String)
], OpportunityFinalNegotiationQcrVariation.prototype, "issue", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_final_negotiation_entity_1.OpportunityFinalNegotiation, (neg) => neg.qcrVariations, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "opportunity_final_negotiation_id" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityFinalNegotiationQcrVariation.prototype, "finalNegotiation", void 0);
exports.OpportunityFinalNegotiationQcrVariation = OpportunityFinalNegotiationQcrVariation = tslib_1.__decorate([
    (0, typeorm_1.Entity)("opportunity_final_negotiation_qcr_variation")
], OpportunityFinalNegotiationQcrVariation);
